// extracted by mini-css-extract-plugin
export default {"container":"TemplateCard_container__wGOo7","template8":"TemplateCard_template8__FzWL-","innertext":"TemplateCard_innertext__lZ-j-"};